import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { DealerService } from '../../../../shared/services/dealer/dealer.service';
import { TranslatorService } from '../../../../shared/services/utils/translator.service';
import { LeadsComunicationService } from '../../../leads/leads-comunication.service';
import { DropdownBaseComponent } from '../dropdown-base.component';
import { DropDownService } from '../dropdown.service';

@Component({
  selector: 'ngx-dealer-selection-dropdown',
  templateUrl: '../template-dropdown.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DealerSelectionDropdownComponent extends DropdownBaseComponent implements OnInit {

  constructor(private readonly dropdownService: DropDownService,
    private readonly dealerService: DealerService,
    protected readonly translatorService: TranslatorService,
    private readonly leadComuService: LeadsComunicationService,
  ) {
    super(translatorService);
  }

  ngOnInit(): void {
    super.ngOnInit();

    this.dropDownSettings = this.dropdownService.getConfiguration(this.singleSelection);
    this.dealerService.dealersQuery$(null, null).subscribe(res => {
      this.itemsData = this.itemsData.concat(res.dealerList);
      this.leadComuService.dealers = res.dealerList;
    });
  }

}
